import { CircularProgress } from "@mui/material"


const Loader = () => (
    <div className="w-[100vw] h-[100vh] flex justify-center items-center">
        <CircularProgress size={100}/>
    </div>
)

export default Loader